<form 
        (ngSubmit)="$event.preventDefault(); saveEmotionalReaction();"
        [formGroup]="emotionalReactionForm"
        class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto"
    >
    <div class="w-full overflow-y-auto px-1">                    
        <h2 class="pb-2 w-full oswald-font text-xl font-medium text-start">
            Emotional Reaction (Select all that apply)
        </h2>
        <div class="w-full flex flex-col items-center gap-4 pb-4">
            <div class="w-full flex flex-col items-start text-start" *ngFor="let question of questionsList">
                <div class="w-full font-semibold">
                  <p>{{ question.question }}</p>
                </div>
                <div class="w-full flex flex-col items-start gap-2">
                    <div class="flex items-center" *ngFor="let answer of question.answers">
                        <input 
                        [id]="question.formControlName + '_' + answer"
                        type="checkbox"
                        [checked]="emotionalReactionForm.get(question.formControlName)?.value.includes(answer)"
                        (change)="onCheckboxChange($event, question.formControlName, answer)"
                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2">
                        <label [for]="question.formControlName + '_' + answer" class="ml-2 text-sm font-medium text-gray-900">{{ answer }}</label>
                    </div>
                </div>
            </div>

            <div class="w-full flex flex-col items-start text-start" *ngFor="let question of radioQuestionList">
                <div class="w-full font-semibold">
                    <p>{{ question.question }}</p>
                </div>
                <div class="w-full flex items-start gap-2">
                    <div>
                        <input type="radio" [id]="question.formControlName + '_yes'" value="{{ yesNo.Yes }}" class="hidden peer" [formControlName]="question.formControlName">
                        <label [for]="question.formControlName + '_yes'"
                        class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                        Yes
                        </label>
                    </div>
                    <div>
                        <input type="radio" [id]="question.formControlName + '_no'" value="{{ yesNo.No }}" class="hidden peer" [formControlName]="question.formControlName">
                        <label [for]="question.formControlName + '_no'"
                        class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50  border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                        No
                        </label>
                    </div>
                </div>
            </div>

            
            <!-- <div class="w-full flex flex-col items-start text-start" *ngFor="let question of questionList">
                <div class="w-full font-semibold">
                    <p>{{ question.question }}</p>
                </div>
                <div class="w-full flex flex-col items-center">
                    <textarea 
                        [formControlName]="question.formControlName"
                        rows="3"
                        class="block p-2 w-full text-sm text-gray-900 bg-gray-50 rounded border border-gray-300"
                        [placeholder]="question.placeholderText"
                    ></textarea>
                </div>
            </div> -->
        </div>
        <div class="w-full flex flex-row gap-2 items-center justify-end">
            <button
                type="submit"
                class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                [ngClass]="{
                    'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': this.emotionalReactionForm.invalid,
                    'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.emotionalReactionForm.valid
                }"
                [disabled]="this.emotionalReactionForm.invalid"
            >
                Save
            </button>
        </div>
    </div>
</form>